export enum PersonalDataAbTestEnum {
  EncouragementBenefitOffers = 'Zobaczysz więcej ofert',
  EncouragementBenefitPrice = 'Poznasz dokładną cenę polisy',
  EncouragementTitle = 'Dlaczego warto uzupełnić te dane?',
  OwnerDataSectionLabel = 'Dane właściciela',
  PersonalDataPathNo = 'Nie chcę podawać danych',
  PersonalDataPathYes = 'Chcę podać dane właściciela',
}
